import { observer } from 'mobx-react';

import { useCountdownTimer } from '../../../hooks';
import { GeneralWidgetTimer } from '../../GeneralWidget';

interface PrizeDropWidgetTimerProps {
  endDate: Date;
  onEnd: () => void;
  extended?: boolean;
}

function PrizeDropWidgetTimerComponent(props: PrizeDropWidgetTimerProps) {
  const { extended, endDate, onEnd } = props;
  const { timer } = useCountdownTimer({ endDate, onEnd });

  return <GeneralWidgetTimer extended={extended} timerValue={timer} />;
}

export const PrizeDropWidgetTimer = observer(PrizeDropWidgetTimerComponent);
